export default function Modal({ isOpen, onClose, title, children }) {
  if (!isOpen) return null;

  return (
    <div
      className={
        (isOpen ? "" : "hidden ") +
        "overflow-y-auto overflow-x-hidden fixed flex top-0 right-0 left-0 justify-center items-center w-full z-999 h-[calc(100%-1rem)] max-h-full"
      }
    >
      <div className="bg-white dark:bg-black p-6 rounded-lg shadow-lg absolute z-999">
        <div className="flex justify-between items-center mb-4">
          {title && <h2 className="text-xl font-semibold">{title}</h2>}
          <button
            type="button"
            className="text-gray-500 hover:text-gray-700"
            onClick={onClose}
          >
            &times;
          </button>
        </div>

        <div dangerouslySetInnerHTML={{ __html: children }} />

        <div className="flex justify-end">
          {/* <button type="button" className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded" onClick={onClose}>
                    OK
                </button> */}
        </div>
      </div>
    </div>
  );
}
